import React, { useCallback, useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FiLink } from "react-icons/fi";

import { useStudyPathSideBar } from "../../../StudyPathSideBar/context";
// Components
import SearchInput from "../../../../components/SearchInput";

// Styles
import styles from "./sources.module.css";

// Utils
// import { courseFilesUrl } from "../../../../utils/urls";
import { mockFilesWithUnits } from "../../../../utils/mocks";
import Spinner from "../../../../components/spinner";

const FileRow = ({ file, loose = false }) => {
  // Handlers
  const handleClick = () => {
    // TODO: Keith/Daniel Download the file from url
    if (!file.url) {
      console.error("No file URL provided");
      return;
    }
    const link = document.createElement('a');
    link.href = file.url;
    link.download = file.name || 'download';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  if (!file) return null;
  const { subunit } = file;

  const renderSubunit = () => {
    if (!subunit) return null;

    return (
      <div className='text-sm text-gray-500'>
        [{subunit.title}]
      </div>
    )
  }

  return (
    <div className={styles.fileRow}>
      <div
        className={`${styles.fileRowLink} text-blue-500`}
        onClick={handleClick}
      >
        <div className={styles.fileRowIcon}>
          <FiLink />
        </div>

        <div className={styles.fileRow__name}>
          {file.name}
        </div>
      </div>

      {renderSubunit()}
    </div>
  )
}

const Sources = () => {
  // Hooks
  const { t } = useTranslation();

  // Context
  const { course } = useStudyPathSideBar();

  // State
  const [search, setSearch] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  // Getters
  const getSources = useCallback(async (query) => {
    if (!course) return;

    setLoading(true);

    // TODO: Keith/Daniel Remove this when the API is ready
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 500));

    const files = mockFilesWithUnits(query);
    setResults(files);

    // TODO: Keith/Daniel Uncomment this when the API is ready
    // try {
    //   const options = {
    //     method: "GET",
    //     headers: { "Accept": "application/json" },
    //   }
    //   let url = courseFilesUrl(course.id);
    //   if (query !== "") url += `?search=${query}`;

    //   const response = await fetch(url, options);
    //   if (response.ok) {
    //     const data = await response.json();
    //     setResults(data);
    //   } else {
    //     console.error("Failed to fetch sources");
    //   }
    // } catch (error) {
    //   console.error(error);
    // }
    setLoading(false);
  }, [course]);

  // Effects
  useEffect(() => {
    if (course) getSources();
  }, [course]);

  // Handlers
  const handleSearch = useCallback((value) => {
    setSearch(value);
    getSources(value);
  }, [getSources]);

  const handleClear = useCallback(() => {
    setSearch("");
    setResults([]);
  }, []);

  // Render
  const renderResults = () => {
    const unitFiles = []
    const looseFiles = []

    results.forEach((result) => {
      if (result.unit) {
        const id = result.unit.id;
        const unit = unitFiles.find((group) => group.id === id);

        if (unit) {
          unit.files.push(result);
        } else {
          unitFiles.push({ id, title: result.unit.title, files: [result] });
        }
      } else {
        looseFiles.push(result);
      }
    });

    return (
      <div className={styles.results}>
        {looseFiles.length > 0 && (
          <div className={`${styles.unit} bg-gray-200 rounded-lg`}>
            <h3>{t('masteryMap.sources.looseFiles')}</h3>

            {looseFiles.map((file) => <FileRow key={file.id} file={file} loose />)}
          </div>
        )}

        {unitFiles.map((unit) => {
          if (unit.files.length === 0) return null;

          return (
            <div
              key={unit.id}
              className={`${styles.unit} bg-gray-200 rounded-lg`}
            >
              <div className="flex flex-col gap-2 text-gray-500">
                {t('masteryMap.sources.unit')}

                <span className="text-md text-black">
                  {unit.title}
                </span>
              </div>

              {unit.files.map((file) => <FileRow key={file.id} file={file} />)}
            </div>
          )
        })}

      </div>
    );
  }

  return (
    <div className={styles.container}>
      {loading && <Spinner />}

      <SearchInput onDebouncedSearch={handleSearch} onClear={handleClear} />

      {renderResults()}
    </div>
  );
};

export default Sources;
